import React, { useEffect, useContext } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  makeStyles,
  Typography,
} from '@material-ui/core';
import { useHistory, useParams } from 'react-router-dom';
import { Skeleton } from '@material-ui/lab';

import { CreateMeetingContext } from '../../../services/create-meeting/create-meeting.context';

import { TitleDescr } from '../components/title-descr';
import { VirtualLink } from '../components/virtual-link';
import { DateTime } from '../components/dateTime';
import Map from '../../../components/Map/Map';
import Place from '../../../components/MeetingSuggestedPlace/Place';
import { MeetingTimeTable } from '../../../components/TimeTable/Meeting/MeetingTimeTable';
import { CreateMeetingMap } from '../components/location/create-meeting-map';
import UploadImageContainer from '../components/upload-image/upload-image-container';
import { SelectPublicMeeting } from '../components/public-meeting';
import { Invitation } from '../components/invitation/invitation';
import { InvitationError } from '../components/invitation-error';

const useStyles = makeStyles((theme) => {
  return {
    submitBox: {
      display: 'flex',
      alignItems: 'center',
    },
    wrapper: {
      margin: '24px 16px 24px 0',
      position: 'relative',
    },
    buttonProgress: {
      color: '#000',
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
  };
});

export const CreateMeeting = ({ state }) => {
  const { states, functions } = useContext(CreateMeetingContext);
  const classes = useStyles();
  const { id } = useParams();
  const history = useHistory();

  const { meeting, loading, error } = states;
  const { resetState, setStates, getMeeting, createMeeting } = functions;

  useEffect(() => {
    if (id) {
      if (state) {
        setStates(state);
      } else {
        getMeeting(id);
      }
    } else {
      resetState();
    }
  }, [id, state]);

  return (
    <form
      noValidate
      autoComplete='off'
      onSubmit={(e) => createMeeting(e, id)}
      encType='multipart/form-data'
    >
      <UploadImageContainer id={id} />

      <TitleDescr id={id} />

      <Invitation id={id} />

      <DateTime id={id} meeting={meeting} />

      {id && meeting ? <Map /> : id && <Skeleton variant='rect' height={300} />}

      {!id && (
        <Box boxShadow={3} height={300}>
          <CreateMeetingMap />
        </Box>
      )}

      <VirtualLink />

      <Box my={2}>
        <Place />
      </Box>

      <Box my={4}>
        <MeetingTimeTable />
      </Box>

      <SelectPublicMeeting />

      <InvitationError />

      <div className={classes.submitBox}>
        <div className={classes.wrapper}>
          {id ? (
            <Button
              type='submit'
              variant='contained'
              size='small'
              color='primary'
              disabled={loading}
              id='create-meeting'
            >
              Update meeting
            </Button>
          ) : (
            <Button
              type='submit'
              variant='contained'
              size='small'
              color='primary'
              disabled={loading}
              id='create-meeting'
            >
              Create meeting
            </Button>
          )}

          {loading && (
            <CircularProgress size={24} className={classes.buttonProgress} />
          )}
        </div>

        {id ? (
          <Button
            size='small'
            variant='outlined'
            disabled={loading}
            onClick={() => history.push(`/meetings-details/${id}`)}
          >
            Discard Changes
          </Button>
        ) : (
          <Button
            size='small'
            variant='outlined'
            disabled={loading}
            onClick={() => {
              localStorage.clear();
              history.push('/meetings');
            }}
          >
            Discard
          </Button>
        )}
      </div>
      {error && <Typography color='error'>{error}</Typography>}
    </form>
  );
};
